import App from "../../../../templates/src/App/App";
import Multiselect from '../../../forms/Inputs/Select/Multiselect';
import Chosen from '../../../forms/Inputs/Select/Chosen';
import StockFilterData from "./Filter.data";
import _ from 'lodash';
import StockLocatorList from "../list/list";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import {gsap} from "gsap";
import Header from "@templates/Header/Header.js";
import FilterRent from "@modules/stock_locator/views/Filter/Filter.rent.js";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

const Filter = {
    el: {},
    data: {},
    category: {},
    form: undefined,
    sortDir: 'asc',

    init: function (collection) {
        this.collection = collection;
        this.el = collection.find('[component="Filter"]');
        this.cars = collection.find('[block="list"] #cars');

        FilterRent.init(this.collection);

        if (!this.el.length) return;

        this.button = this.el.find('nav.filter');
        this.buttonClose = this.el.find('button.close');
        this.buttonShow = this.el.find('button.cars');
        this.buttonReset = this.el.find('.button.reset');
        this.container = this.el.find('.holder');
        this.header = this.el.find('header');
        this.form = this.el.find('form');
        this.height = this.el.outerHeight();

        Multiselect.init(this.form);
        Chosen.init(this.form);

        for (const i in StockFilterData) {
            if (typeof StockFilterData[i].init == 'function') StockFilterData[i].init();

            StockFilterData[i].getEl().attr('filter-key', i)
                .on('change', function (e) {
                    StockFilterData[$(this).attr('filter-key')].dirty = true;
                    Filter.Load_data();
                });
        }

        this.createRibbons();
        this.showReset();
        this.bind();
        this.pinFilter();
    },

    bind() {
        this.button.click((evt) => {
            if ($(evt.currentTarget).is('.active')) {
                this.hide();
            } else {
                this.show();
            }
        });

        this.buttonShow.click((evt) => {
            this.hide();
        });

        this.buttonClose.click((evt) => {
            this.hide();
        });
    },

    pinFilter() {
        if (!App.isDesktop) return;

        ScrollTrigger.create({
            id: 'filterPin',
            trigger: this.el,
            pin: true,
            pinSpacing: false,
            start: "top 150px",
            endTrigger: this.cars,
            end: () => "bottom top+=" + this.getHeight(),
            onLeave: () => {
                this.el.find('.scroller').addClass('end')
            },
            onEnterBack: () => {
                this.el.find('.scroller').removeClass('end')
            },
            invalidateOnRefresh: true,
            // markers: true
        });
    },

    pinFilterRefresh() {
        ScrollTrigger.getById('filterPin').refresh();
    },

    getHeight() {
        return this.container.outerHeight() + 150 + 8;
    },

    resize() {
        if (!this.el.length) return;
        const filterPin = ScrollTrigger.getById('filterPin');

        if (!App.isDesktop) {
            filterPin && filterPin.kill(true);
        } else {
            if (filterPin) {
                filterPin.refresh();
            } else {
                this.pinFilter();
            }
        }
        this.height = this.el.outerHeight();
    },

    scrollToTop() {
        const headerH = Header.el.outerHeight();
        const myTop = this.el.closest('section').offset().top;
        gsap.to($('html, body'), {scrollTo: {y: myTop - headerH }});
    },

    show() {
        this.button.addClass('active');
        this.container.addClass('active');
    },

    hide() {
        this.button.removeClass('active');
        this.container.removeClass('active');
    },

    hasFilter() {
        const url = window.location.pathname;
        const pathArray = url.split('/');
        let hasFilter = false;

        pathArray.forEach((el, i) => {
            if (el.includes(':')) {
                if (el.split(':')[0] !== 'sort' && el.split(':')[0] !== 'page')
                    hasFilter = true;
            }
        });

        return hasFilter;
    },

    showReset() {
        if (this.hasFilter()) {
            this.buttonReset.addClass('visible');
            this.header.addClass('active');
        } else {
            this.buttonReset.removeClass('visible');
            this.header.removeClass('active');
        }
    },

    createUrl: function () {
        const LIST_URL = PAGE_URL.replace(/^\/|\/$/g, '')
            .split('/')
            .filter(function (item) {
                return item.indexOf(':') == -1;
            });

        // console.log("PAGE_URL", PAGE_URL);
        // console.log("LIST_URL", LIST_URL);

        var url = WEB_ROOT + '/' + LIST_URL.join('/');

        //console.log(StockFilterData['karoseria_id'].getValue());

        for (var key in StockFilterData) {
            var filter = StockFilterData[key];
            var value =
                typeof filter.getValueForUrl === 'function'
                    ? filter.getValueForUrl()
                    : filter.getValue();

            if (typeof filter.assertAddToUrl === 'function' && !filter.assertAddToUrl()) continue;
            if (filter.abstract || filter.ignoreUrl || !value) continue;

            url += '/' + filter.name + ':' + value.toString();

            //console.log(url);
        }

        var title = BRAND_NAME.toUpperCase() + ' - vozidlá';

        //console.log(url);

        history.pushState(null, title, url);
    },

    Loader: {
        show: function () {
            Filter.el.attr('load', true);
        },

        hide: function () {
            Filter.el.removeAttr('load');
        },
    },

    createRibbons: function () {
        var container = $('.filterRibbons .inner', this.el);
        if (!container.length) return;

        container.empty();

        for (let key in StockFilterData) {
            const filter = StockFilterData[key];

            if (typeof filter.getRibbon == 'function') {
                container.append(filter.getRibbon());
                continue;
            }

            if (typeof filter.assertAddToUrl == 'function' && !filter.assertAddToUrl()) continue;
            let value = filter.getValue();

            if (filter.ignoreUrl || filter.ignoreRibbon === true || !value) continue;

            if (!$.isArray(value)) value = [value];

            value.map(function (singleVal) {
                const curFilter = filter;
                const title =
                    typeof filter.getTitleByValue == 'function'
                        ? filter.getTitleByValue(singleVal)
                        : singleVal;

                $('<div/>', {class: 'ribbon'})
                    .html(filter.title + ': ' + title)
                    .append(
                        $('<span/>', {class: 'button'}).click(function () {
                            let curValue = curFilter.getValue();
                            if (!$.isArray(curValue)) curValue = [curValue.toString()];

                            const newVal = _.without(curValue, singleVal.toString());
                            curFilter.setValue(newVal, true);
                        }),
                    )
                    .appendTo(container);
            });
        }
    },

    Load_data: function () {
        this.createUrl();
        this.showReset();

        for (let i in StockFilterData)
            if (typeof StockFilterData[i].beforeSend == 'function') StockFilterData[i].beforeSend();

        var post_data = this.form.serialize();
        post_data += '&path=' + window.location.pathname;
        post_data += '&locator_url=' + LOCATOR_URL;


        $.ajax({
            data: post_data,
            dataType: 'json',
            url: WEB_ROOT + '/modules/stock_locator/ajax.php',
            type: 'GET',
            success: (response, textStatus, jqXHR) => {
                if (!response.success) return false;

                const data = Filter.data = response.data;
                this.cars.html(data.items);
                $('.pagination').html(data.pagination);

                // if (!data.items) return;

                //-- Filter kategoria:
                this.setupFilterItem(
                    'category_id',
                    data.filter_kategoria,
                    $('<option/>', {value: ''}).text('Všetky vozidlá'),
                );
                //-- Filter znacka:
                this.setupFilterItem('znacka_id', data.filter_znacka);
                //-- Filter model:
                this.setupFilterItem('model_id', data.filter_model);
                //-- Filter palivo:
                this.setupFilterItem('palivo_id', data.filter_palivo);
                //-- Filter karoseria:
                this.setupFilterItem('karoseria_id', data.filter_karoseria);
                //-- Filter rok vyroby:
                this.setupFilterItem('rok_vyroby', data.filter_rok_vyroby);
                //-- Filter sklad:
                this.setupFilterItem('store_id', data.filter_store);
                //-- Filter sales
                this.setupFilterItem('sales', data.sales);

                this.setupCheckbox('availability_id', data.filter_dostupnost);
                this.setupCheckbox('mileage_id', data.filter_jazdene);

                var setRange = function (filter, min, max, minLimit, maxLimit) {
                    var curValue = filter.getValue();
                    var leftVal = Math.max(min, curValue[0] || min);
                    var rightVal = Math.min(max, curValue[1] || max);
                    filter.setMinMax(min, max);
                    filter.setMinMaxLimit(minLimit, maxLimit);
                    filter.setValue([leftVal, rightVal]);
                };

                //-- cena od do
                setRange(
                    StockFilterData.cena_od_do,
                    data.min_cena,
                    data.max_cena,
                    data.min_cena_limit,
                    data.max_cena_limit,
                );
                setRange(
                    StockFilterData.najazdene_od_do,
                    data.min_km,
                    data.max_km,
                    data.min_km_limit,
                    data.max_km_limit,
                );

                this.createRibbons();
                StockLocatorList.setAnimation(this.cars.find('.car'));
                this.pinFilterRefresh();
                this.scrollToTop();

                setTimeout(() => {
                    FilterRent.init(this.collection);
                }, 500);
            },

            error: function (data, textStatus, jqXHR) {
                console.error(data, textStatus, jqXHR)
            },
        });
    },

    setupCheckbox: function (filter, items) {
        const inputs = $('[filter-key="' + filter + '"] .input');

        inputs.each(function (index) {
            const checkbox = $(this).find('input[type="checkbox"]');

            if (items[index].disabled && !checkbox.is(':checked')) {
                $(this).attr('disabled', '');
            } else {
                $(this).removeAttr('disabled');
            }
        });
    },

    setupFilterItem: function (key, items, emptyItem, optionsCreate) {
        if (!items) return;
        const filter = StockFilterData[key];
        const el = filter.getEl();
        const curValue = filter.getValue();

        el.empty(filter);

        if (emptyItem) el.append(emptyItem);

        typeof optionsCreate == 'function'
            ? optionsCreate(curValue, el)
            : items.map(function (item) {
                let selected = false;
                const option = $('<option/>', {value: item.id}).text(item.name);
                const idVal = item.id.toString();

                selected = (curValue && ((Array.isArray(curValue) && curValue.includes(idVal))
                        || curValue === idVal))
                    || false;

                // console.log(key, 'curValue', curValue, 'item.id', item.id, 'selected', selected, 'disabled', !!item.disabled);

                option.attr('selected', selected);
                option.attr('disabled', !!item.disabled);

                if (item.key) option.attr('key', item.key);

                el.append(option);
            });

        el.trigger('chosen:updated');
        el.multiselect('reload');
    },
};

export default Filter;
